export const Achievements = [

  // Medals: 20 points
  {
    id: 'm1ach',
    title: 'Ah, what a great picture!',
    description:'Add a profile picture',
    // You uploaded a profile picture + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

   {
    id: 'm2ach',
     title: 'First flight, go email birdie, go!',
     description:'Sent your first email',
     // You sent your first SaaSsy email + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
     icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  }, 

  {
    id: 'm3ach',
    title: 'Wee woo, data is in. Reports here we come.',
    description:'Created your first report',
    // You created your first SaaSsy report + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'm4ach',
    title: 'Aw. Your virtual desk looks well cute.',
    description:'Upload a desk picture',
    // You put up your desk picture, you know, to come back to the important things + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'm5ach',
    title: 'Looks like you’ve got some stuff to do mate, nice one for discovering your to do list. ',
    description:'Created your first to do list item',
    // You created your first to do list item + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'm6ach',
    title: 'You discovered all the tool tips! Feel like a pro?',
    description:'Covered all the tool tips',
    // You covered all our smart tips + add date for timelines 
    value: 20,
    indType: '',
    category: 'Medal',
    categoryTier: '',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },


  // Bronze Trophies: 50 points 
  // IF you do icons and not animations you might wana keep them consistent for each trophy level 
  {
    id: 'b1ach',
    title: 'Wow, 10 emails!',
    description:'Sent 10 emails',
    // You sent 10 emails in one day + add date for timelines 
    value: 50,
    indType: '',
    category: 'Bronze Trophy',
    categoryTier: 'Bronze',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'b2ach',
    title: 'Is that a report I see? Amazing!',
    description:'Created 10 reports',
    // You created your first report + add date for timelines 
    value: 50,
    indType: '',
    category: 'Bronze Trophy',
    categoryTier: 'Bronze',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'b3ach',
    title: 'Wheew, ten checked off already!',
    description:'Completed 10 to do list items',
    // You completed the first ever ten items on your to do list + add date for timelines 
    value: 50,
    indType: '',
    category: 'Bronze Trophy',
    categoryTier: 'Bronze',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png'
  },

  // Silver Trophies: 100 Ponts 
  {
    id: 's1ach',
    title: 'You really are keeping the email birdies busy.',
    description:'Sent 250 emails',
    // You sent 250 SaaSsy emails + add date for timelines 
    value: 100,
    indType: '',
    category: 'Silver Trophy',
    categoryTier: 'Silver',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 's2ach',
    title: '10 Reports?! Nice, let’s see if we can get you to 25. Go for gold! ',
    description:'Created 10 reports',
    // You created your first 10 reports + add date for timelines 
    value:100,
    indType: '',
    category: 'Silver Trophy',
    categoryTier: 'Silver',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 's3ach',
    title: '50 to-do list items completed? Cuppa on me!',
    description:'50 to-do list items completed',
    // You completed the first ever 50 items on your to do list + add date for timelines 
    value: 100,
    indType: '',
    category: 'Silver Trophy',
    categoryTier: 'Silver',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

    // Gold Trophies: 250 Ponts 
  {
    id: 'g1ach',
    title: '1000 emails! Teach me to work like you. ',
    description:'Sent 1000 emails',
    // You sent 1000 SaaSsy emails + add date for timelines 
    value: 250,
    indType: '',
    category: 'Gold Trophy',
    categoryTier: 'Gold',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'g2ach',
    title: '25 reports, how are you coping?! ',
    description:'Created 25 reports',
    // You created your first 25 reports + add date for timelines 
    value: 250,
    indType: '',
    category: 'Gold Trophy',
    categoryTier: 'Gold',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },

  {
    id: 'g3ach',
    title: '500 items on your to do list COMPLETED?! A fancier drink this time maybe',
    description:'Completed 500 to-do list items',
    // You completed the first ever 500 items on your to do list + add date for timelines 
    value: 250,
    indType: '',
    category: 'Gold Trophy',
    categoryTier: 'Gold',
    icon: 'https://storage.cloud.google.com/smartsaas-achievement-image-store/m1ach.png',
  },
]